import dayjs, { type Dayjs } from 'dayjs';

export function parseDateParam(value: string | null, fallback: Dayjs): Dayjs {
  if (!value) return fallback;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : fallback;
}

export function formatDateTime(value?: string | null): string {
  return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-';
}

export function compactNumber(value: number): string {
  return new Intl.NumberFormat('zh-CN', {
    notation: value >= 10_000 ? 'compact' : 'standard',
  }).format(value);
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : '操作失败';
}
